module.exports = __webpack_public_path__ + "img/Superb_sword_17.f49ea795.png";